import React from 'react';
import { DOC_TYPES } from '../../constants';

const emptyEntry = () => ({ date: new Date().toISOString().slice(0, 10), note: '' });

const JournalEntryMetaFields = ({
  docType,
  setDocType,
  changelog,
  setChangelog,
}) => {
  const borderClass = 'border-stone-300';
  const labelClass = 'text-stone-700';

  const handleEntryChange = (index, field, value) => {
    setChangelog(changelog.map((entry, i) => (i === index ? { ...entry, [field]: value } : entry)));
  };

  const handleAddEntry = () => {
    setChangelog([emptyEntry(), ...changelog]);
  };

  const handleRemoveEntry = (index) => {
    setChangelog(changelog.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-4">
      <div>
        <label className={`block text-sm font-medium ${labelClass} mb-1`}>Entry type</label>
        <select
          value={docType}
          onChange={(e) => setDocType(e.target.value)}
          className="field"
        >
          <option value={DOC_TYPES.POST}>Standard post</option>
          <option value={DOC_TYPES.LIVING}>Living doc — updated as I learn more</option>
        </select>
      </div>

      {docType === DOC_TYPES.LIVING && (
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <label className={`block text-sm font-medium ${labelClass}`}>Changelog</label>
            <button
              type="button"
              onClick={handleAddEntry}
              className={`text-xs font-medium px-2 py-1 rounded border ${borderClass} hover:bg-white/60 transition`}
            >
              + Add entry
            </button>
          </div>
          {changelog.length === 0 ? (
            <p className={`text-xs ${labelClass} opacity-80`}>No changelog entries yet.</p>
          ) : (
            changelog.map((entry, index) => (
              <div key={index} className="flex gap-2 items-start">
                <input
                  type="date"
                  value={entry.date || ''}
                  onChange={(e) => handleEntryChange(index, 'date', e.target.value)}
                  className="field w-36"
                />
                <input
                  type="text"
                  placeholder="What changed?"
                  value={entry.note || ''}
                  onChange={(e) => handleEntryChange(index, 'note', e.target.value)}
                  className="field flex-1"
                />
                <button
                  type="button"
                  onClick={() => handleRemoveEntry(index)}
                  className="px-2 py-2 text-red-600 hover:bg-red-50 rounded-lg text-sm"
                >
                  Remove
                </button>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default JournalEntryMetaFields;
